(() => {
  if (customElements.get('lt-cart-personalized')) return;
  class LtCartPersonalized extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cartIds = new Set(this.parseIds(this.dataset.cartIds));
      this.cartVendors = this.parseVendors(this.dataset.cartVendors);
      const manual = this.candidates(this.querySelector('[data-lt-complementary]'));
      this.complements = manual.filter(node => node.dataset.verified === 'true');
      this.related = [...manual.filter(node => node.dataset.verified !== 'true'), ...this.candidates(this.querySelector('[data-lt-related]'))];
      this.newProducts = this.candidates(this.querySelector('[data-lt-new]'), true);
      this.render(this.pick([]));
      document.addEventListener('visitorConsentCollected', () => {
        this.recentRequest?.abort();
        this.render(this.pick([]));
        this.loadRecent(this.controller.signal);
      }, { signal: this.controller.signal });
      this.prepareHistory(this.controller.signal);
    }
    disconnectedCallback() {
      this.recentRequest?.abort();
      this.controller?.abort();
      this.controller = null;
    }
    parseIds(raw) {
      try {
        const ids = JSON.parse(raw || '[]');
        return Array.isArray(ids) ? [...new Set(ids.filter(id => Number.isSafeInteger(id) && id > 0).map(String))] : [];
      } catch { return []; }
    }
    normalizeVendor(value) {
      return typeof value === 'string' ? value.trim().toLowerCase() : '';
    }
    parseVendors(raw) {
      try {
        const values = JSON.parse(raw || '[]');
        return new Set(Array.isArray(values) ? values.map(value => this.normalizeVendor(value)).filter(Boolean) : []);
      } catch { return new Set(); }
    }
    candidates(root, allowNew = false) {
      return [...(root?.querySelectorAll('template[data-lt-candidate]') || [])].filter(node => {
        const id = node.dataset.productId;
        const vendor = this.normalizeVendor(node.dataset.vendor);
        return /^\d+$/.test(id || '') && !this.cartIds.has(id) && (allowNew || (vendor !== '' && this.cartVendors.has(vendor)));
      });
    }
    pick(recentIds) {
      const result = [], seen = new Set();
      const add = (node, reason) => {
        if (node && result.length < 3 && !seen.has(node.dataset.productId)) {
          seen.add(node.dataset.productId); result.push({node, reason});
        }
      };
      const rank = nodes => [...nodes].sort((a,b) => {
        const ai=recentIds.indexOf(a.dataset.productId), bi=recentIds.indexOf(b.dataset.productId);
        return (ai<0?Infinity:ai)-(bi<0?Infinity:bi);
      });
      rank(this.complements).forEach(node => add(node,'complementary'));
      rank(this.related).forEach(node => add(node,'related'));
      this.newProducts.forEach(node => add(node,'new'));
      return result;
    }
    render(items) {
      if (!this.isConnected) return;
      const list = this.querySelector('[data-lt-list]');
      if (!list || list.contains(document.activeElement)) return;
      const signature = items.map(item => `${item.node.dataset.productId}:${item.reason}`).join('|');
      if (signature === this.signature) return;
      this.signature = signature;
      const fragment = document.createDocumentFragment();
      for (const item of items) {
        const content = item.node.content.cloneNode(true);
        // Full-cart native product forms reload /cart after a successful AJAX add.
        // Never request drawer opening, including cards fetched from the search section.
        if (this.dataset.surface === 'page') {
          content.querySelectorAll('input[name="on_success"]').forEach(input => input.remove());
        }
        fragment.append(content);
      }
      list.replaceChildren(fragment);
      this.hidden = items.length === 0;
    }
    prepareHistory(signal) {
      if (window.Shopify?.customerPrivacy) {
        this.loadRecent(signal);
      } else if (typeof window.Shopify?.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.2' }], error => {
          if (!error && !signal.aborted && this.isConnected) this.loadRecent(signal);
        });
      }
    }
    loadRecent(signal) {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || typeof privacy.preferencesProcessingAllowed !== 'function' || !privacy.preferencesProcessingAllowed()) return;
      let ids;
      try { ids = this.parseIds(localStorage.getItem('theme:recently-viewed-products')); }
      catch { return; }
      if (!signal.aborted && this.isConnected) this.render(this.pick(ids));
    }

  }
  customElements.define('lt-cart-personalized', LtCartPersonalized);
})();

